<div class="left-panel vertical-dash">
  <div class="panel-header flex flex-col w-100-percent">
    <div class="flex flex-row items-center justify-between">
      @if(isDataLoading) {
        <div class="flex item-center loader">
          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      } @else {
        <div class="flex flex-row items-center">
          <div class="action-title">{{activityDetails?.operation? (activityDetails?.operation | titlecase) : '--' }}</div>
          <div class="flex items-center action-status ml-12 justify-center" [ngClass]="activityDetails?.status" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_STATUS' | transloco: { status: activityDetails?.status | titlecase }">
            <span class="flex items-center" aria-hidden="true">
              @if(activityDetails?.status === 'inprogress') {
                <mat-spinner diameter="16" class="progress-color" mode="indeterminate"></mat-spinner>
              } @else {
                <mat-icon [svgIcon]="statusIcon[activityDetails?.status]" class="h-14 w-14"></mat-icon>
              }
            </span>
            <span aria-hidden="true">{{activityDetails?.status ? (activityDetails?.status | titlecase) : '--'}}</span>
          </div>
        </div>
        @if(activityDetails?.status === 'inprogress') {
          <button type="button" class="abort-action ml-8" [disabled]="isAborting || isRefreshing || !data?.hasEnvUpdatePermission || activityDetails?.instanceDetails?.lastLifecycleOperation?.status?.toLowerCase() !== 'inprogress'" [attr.aria-label]="'INSTANCE_DETAILS.ABORT' | transloco" (click)="onAbortClick()" matTooltipClass="left" [matTooltip]="'INSTANCE_DETAILS.ABORT' | transloco" matTooltipPosition="left">
            <mat-icon svgIcon='stop_circle' class="h-20 w-20 warn-icon"></mat-icon>
          </button>
        }
      }
    </div>
    <mat-divider class="w-100-percent neutral-2 mt-8"></mat-divider>
    <div class="panel-scroll pr-8">
      <div class="activity-details">
      <div class="time-row">
        <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_START_TIME' | transloco: { time: (activityDetails?.startTime ? formatDateTime(toUtcString(activityDetails?.startTime)) : ('ACTIVITY_DETAILS.NOT_AVAILABLE' | transloco)) }">
          <div class="label">{{'ACTIVITY_DETAILS.START_TIME' | transloco}}</div>
          @if(isDataLoading) {
            <div class="flex item-center loader">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          } @else {
            <div class="value" aria-hidden="true">{{activityDetails?.startTime ? formatDateTime(toUtcString(activityDetails?.startTime)) : '--'}}</div>
          }
        </div>
        <div class="detail-item end-time" [attr.aria-label]="(activityDetails?.finishTime ? 'ACTIVITY_DETAILS.ARIA_END_TIME' : 'ACTIVITY_DETAILS.ARIA_EXPECTED_END_TIME') | transloco: { time: (activityDetails?.finishTime ? formatDateTime(toUtcString(activityDetails?.finishTime)) : expectedEndTime) }">
          <div class="label" aria-hidden="true">{{(activityDetails?.finishTime ? 'ACTIVITY_DETAILS.END_TIME' : 'ACTIVITY_DETAILS.EXPEC_END_TIME') | transloco}}</div>
          @if(isDataLoading) {
            <div class="flex item-center loader">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          } @else {
            <div class="value" aria-hidden="true">{{activityDetails?.finishTime ? formatDateTime(toUtcString(activityDetails?.finishTime)) : expectedEndTime}}</div>
          }
        </div>
      </div>
      <div class="detail-item">
        @if(isDataLoading) {
          <div class="flex item-center loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        } @else {
          @if (activityDetails?.finishTime) {
            <div [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_DURATION' | transloco: { duration: calculateDuration(toUtcString(activityDetails?.startTime), toUtcString(activityDetails?.finishTime)), delay: (delayedDuration ? ('ACTIVITY_DETAILS.DELAYED_BY_PREFIX' | transloco) + delayedDuration : '') }">
              <div class="label" aria-hidden="true">{{'ACTIVITY_DETAILS.DURATION' | transloco}}</div>
              <div class="value" aria-hidden="true">{{calculateDuration(toUtcString(activityDetails?.startTime), toUtcString(activityDetails?.finishTime))}}
                @if (delayedDuration) { <span class="delayed">{{ 'ACTIVITY_DETAILS.DELAYED_BY' | transloco: { duration: delayedDuration } }}</span>}
              </div>
            </div>
          } @else {
            @if (elapsedTimeDisplay && elapsedTimeDisplay !== '--') {
              <div class="flex flex-col">
                <mat-progress-bar mode="determinate" [value]="progressPercent" class="progressbar mt-25" matTooltipClass="form-tooltip above" [matTooltip]="progressBarTooltip"
							  matTooltipPosition="above" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_PROGRESS' | transloco: { progress: progressPercent }"></mat-progress-bar>
                <div class="flex justify-end gap-1 mt-6" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_ELAPSED_TIME' | transloco: { elapsed: elapsedTimeDisplay, expected: expectedDuration }">
                  <span class="estimate-time" aria-hidden="true">{{elapsedTimeDisplay}}</span>
                  <span class="remaining-time" aria-hidden="true">of</span>
                  <span class="expected-time" aria-hidden="true"> {{expectedDuration}}</span>
                  <span class="remaining-time" aria-hidden="true">estimated</span>
                </div>
                <mat-divider class="w-100-percent neutral-2 mt-16"></mat-divider>
              </div>
            }
          }
      }
      </div>
      <div class="detail-item" [attr.aria-label]="'ACTIVITY_DETAILS.ARIA_INITIATED_BY' | transloco: { email: (activityDetails?.initiatedBy ? activityDetails?.initiatedBy : ('ACTIVITY_DETAILS.UNKNOWN' | transloco)) }">
        <div class="label" aria-hidden="true">{{'ACTIVITY_DETAILS.START_BY'| transloco}}</div>
        @if(isDataLoading) {
          <div class="flex item-center ml-4 pl-6 pr-16 loader">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        } @else {
          <div class="value email" aria-hidden="true">{{activityDetails?.initiatedBy ? activityDetails?.initiatedBy : '--'}}</div>
        }
      </div>
    </div>
    <mat-divider class="w-100-percent neutral-2 mt-8 mb-24"></mat-divider>


  @if (!isDataLoading && activityDetails?.stages?.length > 0) {
  <div class="stages">
    @for (stage of activityDetails?.stages; let i = $index; track i) {
      <div class="stage p-14 mb-20 cursor-pointer" (click)="onStageClick(stage)" [ngClass]="stage?.status" role="button" tabindex="0"
        [attr.aria-pressed]="stage?.location === selectedStage?.location && stage?.type === selectedStage?.type"
        [class.selected-stage]="stage?.location === selectedStage?.location && stage?.type === selectedStage?.type">
        <span class="primary-tag" [ngClass]="stage?.location" [attr.aria-label]="stage?.location">{{stage?.location | titlecase}}</span>
        <div class="flex justify-between fw-600" [ngClass]="{'mb-2': stage?.status === 'failed', 'mb-6': stage?.status !== 'failed'}">
          <div class="fw-600 fs-14">{{ 'INSTANCE_LIST.STAGE' | transloco }} {{i + 1}} - {{stageTypeText[stage?.type]}}</div>
          <div class="flex flex-col items-end">
            <div>
              @if (!inprogressStatus.includes(stage?.status)) {
                <mat-icon
                  [svgIcon]="completedStatus.includes(stage?.status)
                      ? 'check_circle_filled'
                      : failedStatus.includes(stage?.status)
                      ? 'stop_circle'
                      : ''"
                  class="icon-sm"
                  [class.mt-4]="stage?.status === 'success'"
                  [class.mb-2]="stage?.status === 'failed'"
                  [ngClass]="stage?.status"
                ></mat-icon>
              } @else if(inprogressStatus.includes(stage?.status)){
                <mat-spinner *ngIf="inprogressStatus.includes(stage?.status)" diameter="16" class="progress-color mt-4" mode="indeterminate"></mat-spinner>
              } @else {
                <mat-icon
                  svgIcon="circle" class="icon-md p-2 mt-4">
                </mat-icon>
              }
            </div>
            @if (stage?.status === 'failed') {
            <div class="fs-10 mt-2 failed-text">
              {{stage?.status | titlecase}}
            </div>
            }
          </div>
        </div>
        <div class="flex">
          <div class="fw-500 fs-14 stage-metrics" [ngClass]="stage?.status">{{stage?.startTime | shortDuration : stage?.finishTime}}</div>
          <span class="stage-info-tooltip" [matTooltip]="getTooltipText(stage)" matTooltipPosition="right" matTooltipClass="right stage-tooltip">
            <mat-icon class="info-icon icon-sm ml-8 mt-4" svgIcon="info"></mat-icon>
          </span>
        </div>
      </div>
    }
  </div>
  } @else if (!isDataLoading && activityDetails?.stages?.length === 0) {
    <div
      class="rounded-b-lg rounded-t-none no-result-message text-center pt-24 pb-24 fs-16 fw-500 text-neutral-600">
      <img class="stage-no-data" src="/assets/images/no_result.svg" alt="No data found" />
      <div class="fs-12 no-data-text mt-4">{{ 'INSTANCE_LIST.NO_STAGE_DATA_FOUND' | transloco }}</div>
    </div>
  } @else {
    @for (item of [1]; track item) {
    <div class="flex flex-col stage inprogress mb-20 p-16">
      @for (item of [1,2]; track item; let last = $last) {
        <div [ngClass]="{'mb-12': !last}">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
    }
  }
    </div>
  </div>

  
</div>